import React from 'react';
import type { FabricCanvas } from '../../types/fabric';
import type { ActiveToolId } from './LeftSidebar';
import { TextTool } from '../tools/TextTool';
import { UploadTool } from '../tools/UploadTool';
import { ClipartTool } from '../tools/ClipartTool';
import { ArtworkTool } from '../tools/ArtworkTool';
import { ShapesTool } from '../tools/ShapesTool';
import { BackgroundTool } from '../tools/BackgroundTool';
import { ImageEffectsTool } from '../tools/ImageEffectsTool';
import { TemplateTool } from '../tools/TemplateTool';
import { NameNumberTool } from '../tools/NameNumberTool';
import { MyDesignsTool } from '../tools/MyDesignsTool';
import { QRCodeTool } from '../tools/QRCodeTool';
import { InfoPanel } from '../panels/InfoPanel';
import { PropertyPanel } from '../panels/PropertyPanel';

const PANEL_WIDTH = 280;

const TOOL_MAP: Partial<Record<ActiveToolId, React.ComponentType<{ canvas: FabricCanvas | null }>>> = {
  info:       InfoPanel,
  text:       TextTool,
  upload:     UploadTool,
  clipart:    ClipartTool,
  artwork:    ArtworkTool,
  shapes:     ShapesTool,
  background: BackgroundTool,
  effects:    ImageEffectsTool,
  template:   TemplateTool,
  barcode:    NameNumberTool,
  mydesigns:  MyDesignsTool,
  qrcode:     QRCodeTool,
  // Text/Image edit — opened by clicking a layer in RightPanel's LayerPanel,
  // not from a sidebar icon (no 'edit' entry in SIDEBAR_TOOLS).
  edit:       PropertyPanel,
};

interface LeftToolPanelProps {
  activeTool: ActiveToolId | null;
  canvas: FabricCanvas | null;
}

export function LeftToolPanel({ activeTool, canvas }: LeftToolPanelProps) {
  const isOpen = !!activeTool && activeTool !== 'layers';
  const ActiveTool = activeTool ? TOOL_MAP[activeTool] : null;

  return (
    <div
    className="customedge-scroll"
      style={{
        width: isOpen ? PANEL_WIDTH : 0,
        overflow: 'hidden',
        transition: 'width 0.2s ease',
        flexShrink: 0,
        background: '#ffffff',
        borderRight: isOpen ? '1px solid #e2e8f0' : 'none',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
      }}
    >
      {ActiveTool && (
        // <div style={{ width: PANEL_WIDTH, overflowY: 'auto', overflowX: 'hidden', flex: 1 }}>
        <div
        className="customedge-scroll"
  style={{
    width: PANEL_WIDTH,
    overflowY: 'auto',
    overflowX: 'hidden',
    flex: 1,
    minHeight: 0,
    scrollbarWidth: 'thin',
  }}
>
          <ActiveTool canvas={canvas} />
        </div>
      )}
    </div>
  );
}
